import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireSeason} from '@tisa-group/models';

@Injectable()
export class SeasonService implements CrudService {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSeason[]>> {
    return this.http
      .get(`/seasons`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSeason>> {
    return this.http
      .get(`/seasons/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(seasonId: string): Observable<void> {
    return this.http.delete(`/seasons/${seasonId}`);
  }

  create(season: Partial<UmpireSeason>): Observable<JsonApiResponse<UmpireSeason>> {
    return this.http.post('/seasons', serialize({stuff: season})).pipe(deserialize());
  }

  update(season: Partial<UmpireSeason>): Observable<JsonApiResponse<UmpireSeason>> {
    return this.http
      .patch(`/seasons/${season.id}`, serialize({stuff: season}))
      .pipe(deserialize());
  }
}
